import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

interface SummaryAndControlsProps {
  enabledCount: number;
  totalCount: number;
  totalRemainingRecords: number;
  hasChanges: boolean;
  saving: boolean;
  updating: boolean;
  onSelectAll: () => void;
  onClearAll: () => void;
  onSave: () => void;
}

const SummaryAndControls: React.FC<SummaryAndControlsProps> = ({
  enabledCount,
  totalCount,
  totalRemainingRecords,
  hasChanges,
  saving,
  updating,
  onSelectAll,
  onClearAll,
  onSave,
}) => {
  const isDisabled = saving || updating;

  return (
    <>
      <Box mb={1}>
        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            onClick={onSelectAll}
            disabled={isDisabled}
          >
            Select All
          </Button>
          <Button variant="outlined" onClick={onClearAll} disabled={isDisabled}>
            Clear All
          </Button>
          <Button
            variant="contained"
            startIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
            onClick={onSave}
            disabled={!hasChanges || isDisabled}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </Button>
        </Box>
      </Box>

      <Box>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Summary {updating && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {enabledCount} of {totalCount} flags selected for exclusion
        </Typography>
        <Typography
          variant="body1"
          color="success.main"
          fontWeight="medium"
          sx={{ mb: 1 }}
        >
          Records remaining after exclusions:{' '}
          {totalRemainingRecords.toLocaleString()}
        </Typography>
      </Box>

      {hasChanges && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          You have unsaved changes. Click "Save Changes" to apply your
          modifications.
        </Alert>
      )}
    </>
  );
};

export default SummaryAndControls;
